import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Flex,
    RadioGroup,
    Radio,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { ApproveRequest, ApproveSCN, ApproveSRA, ApproveTransfer, CertifyScn, InventoryAcc, RejectRequest, RejectSCN, RejectSRA, UpdateIir } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { ImPriceTag } from 'react-icons/im';
import { BsFillBookmarkCheckFill } from 'react-icons/bs';



export default function RejectAction({ isOpen, onOpen, onClose, id, qty, state }) {



    const [ApprovePayload, setApprovePayload] = useState({
        supervisorremark: "",
        approvalresponse: false
    });






    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);
    const [LoadingReject, setLoadingReject] = useState(false);


   

    const RejectSra = async () => {
        try {
            setLoadingReject(true)
            if (state === "ApproveSra") {

            }
            console.log("Payloadtransfer", ApprovePayload);
            let result = state === "ApproveSra" ? await RejectSRA(ApprovePayload, id) : state === "ApproveScn" ?
                await RejectSCN(ApprovePayload, id) : state === "ApproveRequest" ?
                    await RejectRequest(ApprovePayload, id) : await ApproveTransfer(ApprovePayload, id)
            console.log("result", result);
            if (result.status == true) {
                setLoadingReject(false)
                setSuccessMsg({
                    status: true,
                    msg: "Rejected successfully"
                })


                setApprovePayload({
                    supervisorremark: "",
                    approvalresponse: false
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                  onClose()

                }, 3000);

            } else {
                setLoadingReject(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setApprovePayload({
                        supervisorremark: "",
                        approvalresponse: false
                    })
                    setErrorMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            }


        } catch (e) {

            setLoadingReject(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })

            setTimeout(() => {
                setErrorMsg({
                    status: false,
                    msg: e.message
                })

            }, 3000);
            console.error('Error:', e.message);
        }


    }
 
   

  
    const handleApprovePayload = (e) => {
        setApprovePayload({ ...ApprovePayload, [e.target.id]: e.target.value })
    }

    console.log("ApprovePayload", ApprovePayload)

    useEffect(() => {

    }, [isOpen]);



    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Reject</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {
                        (state === "ApproveSra" || state === "ApproveScn" || state === "ApproveRequest" || state === "ApproveTransfer") && (

                            <div>

                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<BsFillBookmarkCheckFill />} iconColor="black" labelBg='#fff' label='Supervisor Remark' id="supervisorremark" type='text' value={ApprovePayload.supervisorremark} val={ApprovePayload.supervisorremark != "" ? true : false} onChange={handleApprovePayload} />


                                </Stack>



                                <Flex justifyContent={"center"}>
                                    <Button w='45%' mt="14px" isLoading={LoadingReject}
                                        disabled={ApprovePayload.supervisorremark != "" ? false : true}
                                        onClick={RejectSra} background="red">Reject
                                    </Button>


                                </Flex>
                            </div>
                        )
                    }



                    {
                        errorMsg.status && (
                            <Text mt={"10px"} color="red.200" textAlign="center">{errorMsg.msg}</Text>
                        )
                    }

                    {
                        SuccessMsg.status && (
                            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                        )
                    }

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
